<nz-table #basicTable [nzData]="pending()" [nzFrontPagination]="true">
	<thead>
		<tr>
			<th>File Name</th>
			<th>Template Type</th>
			<th>Successful Rows</th>
			<th>Failed Rows</th>
			<th>Actions</th>
		</tr>
	</thead>
	<tbody>
		@for (data of basicTable.data; track data) {
			<tr>
				<td>{{ data.file.fileName }}</td>
				<td>{{ data.templateType }}</td>
				<td>{{ data.parseResult.success.length }}</td>
				<td>{{ data.parseResult.failed.length }}</td>
				<td>
					<a
						nz-popconfirm
						nzPopconfirmTitle="Are you sure remove this pending file?"
						nzPopconfirmPlacement="bottom"
						(nzOnConfirm)="removePendingFile(data)"
					>
						Disable
					</a>
					<br />
					<a
						nz-popconfirm
						nzPopconfirmTitle="Are you sure you want to apply this pending file? You will have a chance to preview and edit all imported rows."
						nzPopconfirmPlacement="bottom"
						(nzOnConfirm)="applyPendingFile(data)"
					>
						Apply to Preview
					</a>
				</td>
			</tr>
		}
	</tbody>
</nz-table>
